import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

// Add/Remove users as server admin.
// Grants or revokes server admin privledges to the list of users passed in based on the value
// of the 'serverAdmin' boolean. 'true' = grant, 'false' = revoke.
// Also, the server admin flag takes priority over any site role a user may have. It should be an independent field associated with each
// user record and setting it should not clear a user's site role. If the server admin flag is unset for a user, their previously set site role should be restored.
export interface IUpdateServerUsersAdminStatusParams {
  userIds: string[];
  admin: boolean;
}

export interface IUpdateServerUsersAdminStatusResult extends IResult {

}

export class UpdateServerUsersAdminStatusRequest extends Request<IUpdateServerUsersAdminStatusParams, IUpdateServerUsersAdminStatusResult> {
  constructor(params: IUpdateServerUsersAdminStatusParams) {
    super('updateServerUsersAdminStatus', params);
  }
}
